import { getStaticPropsGenerator } from '@cinch-nx/landing-feature-articles-sub-hub'

const path = 'guides/ask-the-experts'
const resultsPerPage = 10

export const getStaticProps = getStaticPropsGenerator({
  subHubPath: path,
  resultsPerPage,
  breadCrumbs: [
    { text: 'Home', url: '/' },
    { text: 'Guides', url: '/guides' },
    { text: 'Ask the experts', url: `/${path}` },
  ],
})

export { ArticleSubHubFeature as default } from '@cinch-nx/landing-feature-articles-sub-hub'
